
module.exports = function register(BoringInjections) {

  return {
    runOrder: 10,
    baseDir: __dirname,
    run: async (params) => {
      return params;
    },
  };
};

